import { get } from 'lodash';

export const getConnectionTries = state =>
  get(state, 'SignalRState.connectionTries');



// WEBPACK FOOTER //
// ./src/api/SignalR/state/selectors.js